import React from "react";
import styled from "styled-components";

const Container = styled.div`
  background: white;
  height: 100%;
`;

const InnerContainer = styled.div`
  margin: 0 auto;
  max-width: 1200px;
`;

class OldBrowser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container>
        <InnerContainer>
          <h1>Denna webbsida kräver en modern webbläsare!</h1>
          <p>
            <b>
              Tyvärr använder du en webbläsare som inte stödjer den senaste
              tekniken.
            </b>
          </p>
          <h2>Windows</h2>
          <p>
            Om du har Windows 10 som operativsystem på din dator, så har du
            redan en modern webbläsare.<br />
            Den heter{" "}
            <a href="https://www.microsoft.com/sv-se/windows/microsoft-edge">
              Microsoft Edge
            </a>. Använd den istället för Internet Explorer.
          </p>
          <h2>Mac</h2>
          <p>
            Använder du Apple Safari, så behöver du minst version 11.<br />
            Du kan uppgradera till den senaste versionen genom att installera de
            senaste uppgraderingarna för din macOS-version.{" "}
            <a href="https://support.apple.com/sv-se/HT204416">Apple Safari</a>
          </p>
          <h4>
            Annars kan du använda någon av dessa webbläsare, som är helt gratis
            och fungerar på både Mac och Windows.
          </h4>
          <p>
            <div>
              <a href="https://support.google.com/chrome/answer/95346?co=GENIE.Platform%3DDesktop&hl=sv">
                Google Chrome
              </a>
            </div>
            <div>
              <a href="https://www.mozilla.org/sv-SE/firefox/new/">
                Mozilla Firefox
              </a>
            </div>
            <div>
              <a href="https://brave.com/download/">Brave</a>
            </div>
          </p>
        </InnerContainer>
      </Container>
    );
  }
}

export default OldBrowser;
